module.exports = __webpack_public_path__ + "static/media/MDG.1aa3fefa.svg";